export default function gt(first: number, second: number) {
  return first > second;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    gt: typeof gt;
  }
}
